module.exports = __webpack_public_path__ + "img/radio-dark.dc73040b.png";